import { MobileAccountBlockStyled } from '../styled/MobileAccountBoxStyled';
import MobileAccountBoxEquity from '../MobileAccountBoxEquity';
import MobileAccountBoxHeader from '../MobileAccountBoxHeader';
import MobileAccountBoxStatPl from '../MobileAccountBoxBlockPl/MobileAccountBoxStatPl';
import MobileAccountBoxButtonsBlock from '../MobileAccountBoxButtonsBlock/MobileAccountBoxButtonsBlock';
import React from 'react';
import MobileAccountBoxHeaderButtons from '../MobileAccountBoxHeaderButtons';

function MobileAccountBoxContent() {
    return <MobileAccountBlockStyled>

        <MobileAccountBoxHeader/>

        <div className={'d-flex justify-content-between'}>
            <div className={'equity-pl'}>
                <MobileAccountBoxEquity/>
                <MobileAccountBoxStatPl/>
            </div>
            <MobileAccountBoxHeaderButtons/>
        </div>
        <MobileAccountBoxButtonsBlock/>
    </MobileAccountBlockStyled>;
}

export default MobileAccountBoxContent;
